import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { RunConditions } from './RunConditions';
import { Field, FieldDescription, FieldLabel } from '@/Domain/components/Shared/Field/Field';
import { HttpActionForm } from '@/Domain/hooks/Action/ApiAction/useHttpRequestActionFormV2.hook';

type Props = {
  form: UseFormReturn<HttpActionForm>;
  isTrigger?: boolean;
};

export const RunConditionsSection = ({ form, isTrigger = false }: Props) => {
  const { t } = useTranslation('actions_page', { keyPrefix: 'sheet.form.run_conditions' });
  const { t: tCommon } = useTranslation('common');

  return (
    <div id="run_conditions" className="space-y-7">
      <Field>
        <FieldLabel>{t(isTrigger ? 'trigger_label' : 'label')}</FieldLabel>
        <FieldDescription>{t(isTrigger ? 'trigger_description' : 'description')}</FieldDescription>
        <a
          href="https://docs.quickchat.ai/ai-agent/actions/#run-only-when"
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${tCommon('learn')}: ${t(isTrigger ? 'trigger_label' : 'label')}`}
          className="mt-1 inline-block text-sm text-primary hover:underline"
        >
          {tCommon('learn')}
        </a>
      </Field>

      <RunConditions form={form} />
    </div>
  );
};
